<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" md="4">
        <v-select
          v-model="selectProspector"
          label="Prospector"
          :items="prospectadores"
          :disabled="btnSearchLoading"
          outlined
        />
      </v-col>
      <v-col cols="12" md="4">
        <v-select
          v-model="selectEstadoNegociacion"
          label="Estado negociación"
          :items="estadoNegociacion"
          :disabled="btnSearchLoading"
          outlined
        />
      </v-col>
      <v-col cols="12" md="1">
        <v-btn
          block
          :loading="btnSearchLoading"
          @click="filtersMaps"
        >
          Buscar
        </v-btn>
      </v-col>
    </v-row>

    <v-row no-gutters>
      <v-col cols="12">
        <div style="width: 100%; height: 80vh">
          <GmapMap
            :center="center"
            :zoom="zoomMap"
            style="width: 100%; height: 100%"
          >
            <GmapMarker
              v-for="(m, index) in markers"
              :key="index"
              :position="m.position"
              :clickable="true"
              :draggable="false"
              :icon="{ url: m.detalle.icon }"
              @click="clickMarker(m)"
            />

            <v-bottom-sheet v-model="sheet">
              <v-sheet class="text-center" height="200px">
                <v-btn
                  class="mt-6"
                  text
                  color="red"
                  @click="sheet = false"
                >
                  Cerrar
                </v-btn>
                <div class="py-3">
                  <v-row>
                    <v-col>
                      <v-container>
                        <v-row>Nombre del proyecto: {{ detalleMarker.nombre_proyecto }}</v-row>
                        <v-row>Estado de negociación: {{ detalleMarker.estadoNegociacion }}</v-row>
                        <v-row>Etapa de Obra: {{ detalleMarker.etapa_obra }}</v-row>
                        <v-row>Prospector: {{ detalleMarker.prospector }}</v-row>
                      </v-container>
                    </v-col>
                  </v-row>
                </div>
              </v-sheet>
            </v-bottom-sheet>
          </GmapMap>
        </div>
        <v-snackbar
          v-model="noResultsSnackbar"
          timeout="1200"
          color="warning"
          top
        >
          No existen proyectos con los filtros seleccionados.
        </v-snackbar>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import firebase from 'firebase'
  const db = firebase.firestore()

  export default {
    data () {
      return {
        estadoNegociacion: ['Todos'],
        prospectadores: ['Todos'],
        detalleMarker: {
          codigo_proyecto: '',
          categoria: '',
        },
        selectProspector: 'Todos',
        selectEstadoNegociacion: 'Todos',
        sheet: false,
        markers: [],
        center: {
          lat: 0,
          lng: 0,
        },
        zoomMap: 13,
        btnSearchLoading: false,
        noResultsSnackbar: false,
      }
    },
    mounted () {
      this.getProspectores()
      this.$store.state.estadoNegociacion.forEach(estado => {
        this.estadoNegociacion.push(estado)
      })
      this.getItemsAll()
      this.$getLocation().then(coordinates => {
        this.center.lat = coordinates.lat
        this.center.lng = coordinates.lng
      })
    },
    methods: {
      getProspectores() {
        const filteredProfiles = []
        firebase.firestore().collection('perfiles').get().then((prospectoresSnapshot) => {
          prospectoresSnapshot.forEach((prospector) => {
            const data = prospector.data()
            if (
              data &&
              data.Proyectos &&
              data.Proyectos.Prospección === true
            ) {
              filteredProfiles.push(prospector.id)
            }
          })
          console.log("Perfiles filtrados:", filteredProfiles)
          firebase.firestore().collection('users').get().then((usersSnapshot) => {
            usersSnapshot.forEach((user) => {
              const userData = user.data()
              if (filteredProfiles.includes(userData.perfil)) {
                this.prospectadores.push(userData.email)
                console.log("Usuario Permitido: ", userData.email)
              }
            })
          })
        })
      },
      getItemsAll () {
        this.btnSearchLoading = true
        this.datos = []
        db.collection('proyectos').get().then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            const data = {
              codigo: doc.data().codigo,
              latitud: doc.data().latitud,
              longitud: doc.data().longitud,
              nombre: doc.data().nombre,
              direccion: doc.data().direccion,
              distrito: doc.data().distrito,
              tipo: doc.data().tipo,
              categoria: doc.data().categoria,
              estado: doc.data().estado,
              numeroPisos: doc.data().numeroPisos,
              numeroDepartamentos: doc.data().numeroDepartamentos,
              etapa: doc.data().etapa,
              estadoNegociacion: doc.data().estadoNegociacion,
              prospector: doc.data().prospector,
              fechaEntrega: doc.data().fechaEntrega,
              inmobiliaria: doc.data().inmobiliaria,
              constructora: doc.data().constructora,
              proveedorActual: doc.data().proveedorActual,
            }
            var icon = ''
            if (data.estadoNegociacion === 'POR VISITAR') {
              icon = 'http://maps.google.com/mapfiles/ms/icons/orange-dot.png'
            } else if (data.estadoNegociacion === 'NEGOCIACIÓN') {
              icon = 'http://maps.google.com/mapfiles/ms/icons/blue-dot.png'
            } else if (data.estadoNegociacion === 'GANADO') {
              icon = 'http://maps.google.com/mapfiles/ms/icons/green-dot.png'
            } else if (data.estadoNegociacion === 'PERDIDO') {
              icon = 'http://maps.google.com/mapfiles/ms/icons/red-dot.png'
            } else {
              icon = 'https://maps.google.com/mapfiles/ms/icons/purple-dot.png'
            }
            this.markers.push({
              detalle: {
                estadoNegociacion: data.estadoNegociacion,
                codigo_proyecto: data.codigo,
                nombre_proyecto: data.nombre,
                prospector: data.prospector,
                icon: icon,
                etapa_obra: data.etapa,
                numero_departamentos: data.numeroDepartamentos,
              },
              position: {
                lat: data.latitud,
                lng: data.longitud,
              },
            })
            this.btnSearchLoading = false
          })
        })
      },
      clickMarker (m) {
        this.detalleMarker = m.detalle
        this.zoomMap = 20
        this.sheet = true
        this.center = m.position
      },
      filtersMaps () {
        this.markers = []
        this.btnSearchLoading = true
        var query = firebase.firestore().collection('proyectos')
        if (this.selectProspector !== 'Todos') {
          query = query.where('prospector', '==', this.selectProspector)
        }
        if (this.selectEstadoNegociacion !== 'Todos') {
          query = query.where('estadoNegociacion', '==', this.selectEstadoNegociacion)
        }
        query.get().then(proyectos => {
          if (proyectos.empty) {
            this.noResultsSnackbar = true
            this.btnSearchLoading = false
            return
          }
          proyectos.forEach(proyecto => {
            const data = {
              codigo: proyecto.data().codigo,
              latitud: proyecto.data().latitud,
              longitud: proyecto.data().longitud,
              nombre: proyecto.data().nombre,
              direccion: proyecto.data().direccion,
              distrito: proyecto.data().distrito,
              tipo: proyecto.data().tipo,
              categoria: proyecto.data().categoria,
              estado: proyecto.data().estado,
              numeroPisos: proyecto.data().numeroPisos,
              numeroDepartamentos: proyecto.data().numeroDepartamentos,
              etapa: proyecto.data().etapa,
              estadoNegociacion: proyecto.data().estadoNegociacion,
              prospector: proyecto.data().prospector,
              fechaEntrega: proyecto.data().fechaEntrega,
              inmobiliaria: proyecto.data().inmobiliaria,
              constructora: proyecto.data().constructora,
              proveedorActual: proyecto.data().proveedorActual,
            }
            var icon = ''
            if (data.estadoNegociacion === 'POR VISITAR') {
              icon = 'http://maps.google.com/mapfiles/ms/icons/orange-dot.png'
            } else if (data.estadoNegociacion === 'POR COTIZAR') {
              icon = 'http://maps.google.com/mapfiles/ms/icons/yellow-dot.png'
            } else if (data.estadoNegociacion === 'NEGOCIACIÓN') {
              icon = 'http://maps.google.com/mapfiles/ms/icons/blue-dot.png'
            } else if (data.estadoNegociacion === 'GANADO') {
              icon = 'http://maps.google.com/mapfiles/ms/icons/green-dot.png'
            } else if (data.estadoNegociacion === 'PERDIDO') {
              icon = 'http://maps.google.com/mapfiles/ms/icons/red-dot.png'
            }
            this.markers.push({
              detalle: {
                estadoNegociacion: data.estadoNegociacion,
                codigo_proyecto: data.codigo,
                nombre_proyecto: data.nombre,
                prospector: data.prospector,
                icon: icon,
                etapa_obra: data.etapa,
                numero_departamentos: data.numeroDepartamentos,
              },
              position: {
                lat: data.latitud,
                lng: data.longitud,
              },
            })
          })
          this.btnSearchLoading = false
        })
      },
    },
  }
</script>
